module.exports = __webpack_public_path__ + "static/media/inviteSuccess.1ee7e53a.png";